// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/mf-atf-broadcast-phraseology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/mf-atf-broadcast-phraseology/mf-atf-broadcast-phraseology.js';

mount([g0]);
